import React, { useEffect, useState } from 'react'
import IconCookies from '../icons/Cookies'
import { useTranslation } from 'react-i18next';

const Cookies = () => {
    const { t } = useTranslation();
    const [isAccepted, setIsAccepted] = useState<boolean>(false);

    useEffect(() => {
        const hasAccepted = localStorage.getItem('cookiesAccepted');
        if (hasAccepted) {
            setIsAccepted(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookiesAccepted', 'true');
        setIsAccepted(true);
    };

    if (isAccepted) return null;

    return (
        <div className='fade-in-bottom bg-black/50 border-2 border-white/10 backdrop-blur-lg gap-2 p-2 lg:px-4 flex items-center w-11/12 mx-auto rounded-2xl'>
            <IconCookies className='h-8 w-8' />
            <p className='flex-1'>{t('common.this_website_uses_cookies')}</p>
            <button
                type='button'
                onClick={handleAccept}
                aria-label="Accept"
                className='shrink-0 rounded-xl bg-primary px-4 py-2 text-sm font-semibold text-white transition hover:bg-primary-shadow'
            >
                {t('common.accept')}
            </button>
        </div>
    )
}

export default Cookies;
